import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';

interface TowInstructionsSectionProps {
	loading: boolean;
}

const TowInstructionsSection: React.FC<TowInstructionsSectionProps> = ({
	loading,
}) => {
	const { control, watch } = useFormContext<ParkingLocation>();
	const towPolicyType = watch('towPolicyType');

	return (
		<Box data-tour="tow-instructions" display="flex" flexDirection="column" gap={2}>
			<Typography variant="body2" fontWeight={300} color="primary">
				After Tow Instructions
			</Typography>
			{towPolicyType === 'never' ? (
				<>
					<Typography
						variant="body2"
						fontWeight={300}
						color="text.secondary"
					>
						Towing policy is set to never tow. No towing company or
						instructions are required.
					</Typography>
				</>
			) : (
				<>
					<Box display="flex" alignItems="center" gap={1}>
						<Typography variant="body2" fontWeight={300}>
							Company Name:
						</Typography>
						<Controller
							control={control}
							name="towingCompanyName"
							render={({ field }) => (
								<TextField
									{...field}
									variant="outlined"
									size="small"
									sx={{ width: 250 }}
									disabled={loading}
								/>
							)}
						/>
					</Box>

					<Box display="flex" alignItems="center" gap={1}>
						<Typography variant="body2" fontWeight={300}>
							Company Number:
						</Typography>
						<Controller
							control={control}
							name="towingCompanyNumber"
							render={({ field }) => (
								<TextField
									{...field}
									variant="outlined"
									size="small"
									sx={{ width: 250 }}
									disabled={loading}
								/>
							)}
						/>
					</Box>

					<Controller
						control={control}
						name="towInstructions"
						render={({ field }) => (
							<TextField
								{...field}
								variant="outlined"
								label="Instructions"
								multiline
								minRows={3}
								fullWidth
								disabled={loading}
							/>
						)}
					/>
				</>
			)}
		</Box>
	);
};

export default TowInstructionsSection;
